import type { BookerNoticeSeverityDto, PublicBookerNoticeDto } from "@calcom/features/booker-notices/types";
import { markdownToSafeHTMLClient } from "@calcom/lib/markdownToSafeHTMLClient";
import type { AlertProps } from "@calcom/ui/components/alert";
import { Alert } from "@calcom/ui/components/alert";

const ALERT_SEVERITY: Record<BookerNoticeSeverityDto, AlertProps["severity"]> = {
  INFO: "info",
  WARNING: "warning",
  URGENT: "error",
};

type BookerNoticeBannerProps = {
  notice: Pick<PublicBookerNoticeDto, "title" | "body" | "severity">;
};

export function BookerNoticeBanner({ notice }: BookerNoticeBannerProps) {
  return (
    <Alert
      severity={ALERT_SEVERITY[notice.severity]}
      title={notice.title ?? undefined}
      message={
        <div
          className="break-words [&_a]:underline [&_p]:m-0"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: Content is sanitized via markdownToSafeHTMLClient
          dangerouslySetInnerHTML={{ __html: markdownToSafeHTMLClient(notice.body) }}
        />
      }
    />
  );
}
